import { render, staticRenderFns } from "./RwRouteNew.vue?vue&type=template&id=4b6428aa&scoped=true&"
import script from "./RwRouteNew.vue?vue&type=script&lang=ts&"
export * from "./RwRouteNew.vue?vue&type=script&lang=ts&"
import style0 from "./RwRouteNew.vue?vue&type=style&index=0&id=4b6428aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6428aa",
  null
  
)

export default component.exports